import React, {useContext} from "react";
import {MarketCategory} from "@interfaces/user/market";

const MarketCategoryContext = React.createContext<MarketCategory>(undefined as any);
export const MarketCategoryProvider = MarketCategoryContext.Provider;

export function useMarketCategoryContext(): MarketCategory | undefined {
    return useContext(MarketCategoryContext);
}